import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChange } from '@angular/core';
import { LaborService } from '../labor.service';
import { NodeData } from '../customItem';
@Component({
  selector: 'app-labortree',
  templateUrl: './labortree.component.html',
  styleUrls: ['./labortree.component.css']
})

export class LabortreeComponent implements OnInit, OnChanges {
  @Input() allLabors = [];
  @Output() setParentCat = new EventEmitter<NodeData>();
  @Input() parentName = "";

  nodes = [];
  isLoading = false;
  constructor(private laborService: LaborService) { }

  ngOnInit() {
    this.populateTree();
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes.hasOwnProperty("allLabors")) {
      if (changes["allLabors"].currentValue != changes["allLabors"].previousValue) {
        this.allLabors = changes["allLabors"].currentValue;
        this.populateTree();
      }
    }
  }

  refreshCat(): void {
    this.laborService.getLabors()
      .subscribe(labors => {
        labors.sort(function (a, b) {
          if (a.Title < b.Title) return -1;
          if (a.Title > b.Title) return 1;
          return 0;
        });
        this.allLabors = labors.filter(l => l["Type"] != "Terminal" && l["Type"] != "Addon");
        this.populateTree();
      });
  }

  populateTree(): void {
    if (this.allLabors != undefined && this.allLabors.length > 0) {
      this.nodes = this.getNestedChildren(this.allLabors, 0);
    }
  }

  changeCategory(node: any): void {
    let nodeData = new NodeData();
    nodeData.LaborGuideId = node.item.LaborGuideId;
    nodeData.Name = node.item.Title;

    this.setParentCat.emit(nodeData);
  }

  getNestedChildren(labors: any, parentId: any): any {
    var out = []
    for (var i in labors) {
      if (labors[i].ParentId == parentId) {
        let laborItem = { id: '', name: '' };
        laborItem.name = labors[i].Title;
        laborItem.id = labors[i].AddonId.toString();
        laborItem['item'] = labors[i];
        // no check children for addon

        var children = this.getNestedChildren(labors, labors[i].LaborGuideId);
        if (children.length) {
          laborItem['children'] = children
        }
        out.push(laborItem)
      }
    }

    return out
  }
}
